var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "pt-4 px-3 d-flex h-100 overflow-auto" }, [
    _c(
      "div",
      { staticClass: "row d-flex h-100 overflow-auto flex-fill" },
      [
        _setup.hasFieldsets
          ? [
              _c(
                "div",
                { staticClass: "col-3 col-lg-2 pb-3 overflow-auto h-100" },
                [
                  _c(_setup.ContentTypeFieldsetsList, { staticClass: "mb-3" }),
                  _vm._v(" "),
                  _c(_setup.ContentTypeNewFieldsetBtn),
                  _vm._v(" "),
                  _c(_setup.ContentTypeFieldsetOffcanvas),
                ],
                1
              ),
              _vm._v(" "),
              _setup.fieldsetId
                ? _c(
                    "div",
                    { staticClass: "col-3 col-lg-2 pb-3 overflow-auto h-100" },
                    [
                      _c(_setup.ContentTypeFieldsList, { staticClass: "mb-3" }),
                      _vm._v(" "),
                      _c(_setup.ContentTypeNewAttributeBtn),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 col-lg-8 overflow-auto h-100" },
                [
                  _setup.activeEditId >= 0
                    ? _c(_setup.ContentTypeFieldEditForm)
                    : _vm._e(),
                ],
                1
              ),
            ]
          : [
              _c(
                "div",
                { staticClass: "col-sm-3 overflow-auto h-100" },
                [
                  _c(_setup.ContentTypeFieldsList),
                  _vm._v(" "),
                  _c(_setup.ContentTypeNewAttributeBtn),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-9 overflow-auto h-100" },
                [
                  _setup.activeEditId >= 0
                    ? _c(_setup.ContentTypeFieldEditForm)
                    : _vm._e(),
                ],
                1
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }